import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { packageTypes, currencies, subPackagingTypes, serviceTypesDomestic, serviceTypesInternational, indiciaTypes } from '../../../utils/dropdownOptions';

export const PackageAndShipmentDetails = ({ formik, isReturnShipmentTab }) => {
    const values = isReturnShipmentTab ? formik.values.returnData : formik.values;
    const errors = isReturnShipmentTab ? formik.errors.returnData : formik.errors;
    const touched = isReturnShipmentTab ? formik.touched.returnData : formik.touched;
    const isMps = values.mpsPackages.length > 0;

    const getTotalWeight = () => {
        let totalWeight = 0;
        values.mpsPackages.forEach((p) => totalWeight += +p.weight);
        return totalWeight;
    }

    const getTotalValue = () => {
        let totalValue = 0;
        values.mpsPackages.forEach((p) => totalValue += +p.declaredValue);
        return totalValue;
    }

    return (
        <>
            {values.country && values.country !== 'US' &&
                <Form.Group className='form-group'>
                    <Form.Label>Package contains</Form.Label>
                    <br />
                    <Form.Check
                        inline
                        type='radio'
                        id='document'
                        label='Document'
                        checked={values.packageContains === 'document'}
                        onChange={formik.handleChange}
                        value='document'
                        name={isReturnShipmentTab ? 'returnData.packageContains' : 'packageContains'}
                        disabled={values.commodities.length > 0}
                    />
                    <Form.Check
                        inline
                        type='radio'
                        id='commodity'
                        label='Commodity/Merchandise'
                        checked={values.packageContains === 'commodity'}
                        onChange={formik.handleChange}
                        value='commodity'
                        name={isReturnShipmentTab ? 'returnData.packageContains' : 'packageContains'}
                        disabled={values.commodities.length > 0}
                    />
                </Form.Group>
            }
            {isReturnShipmentTab &&
                <Form.Group className='form-group'>
                    <Form.Label>Return label type</Form.Label>
                    <Form.Select
                        id='returnData.returnLabelType'
                        {...formik.getFieldProps('returnData.returnLabelType')}
                    >
                        <option value=''>Select an option</option>
                        <option value='PENDING'>Email label</option>
                        <option value='PRINT_RETURN_LABEL'>Print</option>
                        <option value='GROUND_CALL_TAG'>Ground call tag</option>
                    </Form.Select>
                </Form.Group>}
            <Form.Group className='form-group'>
                <Form.Label>Number of packages</Form.Label>
                <InputGroup>
                    <Form.Control
                        id={isReturnShipmentTab ? 'returnData.numPackages' : 'numPackages'}
                        type='number'
                        onWheel={(e) => e.target.blur()}
                        disabled={isMps}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.numPackages' : 'numPackages')}
                        value={values.replaceNumPackagesValue ? values.mpsPackages.length : values.numPackages}
                    />
                    <InputGroup.Checkbox
                        id={isReturnShipmentTab ? 'returnData.identicalPackages' : 'identicalPackages'}
                        checked={values.identicalPackages && values.numPackages > 1}
                        disabled={values.numPackages < 2 || isMps}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.identicalPackages' : 'identicalPackages')}
                    />
                    <InputGroup.Text className='group-check-label'>Identical packages</InputGroup.Text>
                </InputGroup>
            </Form.Group>
            <Form.Group className='form-group'>
                <Form.Label>{isReturnShipmentTab ? 'Estimated weight' : 'Weight'}</Form.Label>
                <InputGroup>
                    <Form.Control
                        id={isReturnShipmentTab ? 'returnData.weight' : 'weight'}
                        type='number'
                        onWheel={(e) => e.target.blur()}
                        disabled={isMps}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.weight' : 'weight')}
                        value={isMps ? getTotalWeight() : values.weight}
                    />
                    <Form.Select
                        id={isReturnShipmentTab ? 'returnData.weightUnit' : 'weightUnit'}
                        disabled={isMps}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.weightUnit' : 'weightUnit')}
                    >
                        <option value='LB'>lbs</option>
                        <option value='KG'>kgs</option>
                    </Form.Select>
                    <InputGroup.Text>Man wt.</InputGroup.Text>
                </InputGroup>
                {
                    (errors?.weight || errors?.weightUnit) && (touched?.weight || touched?.weightUnit) ? (
                        <div className='error'>{errors?.weight || errors?.weightUnit}</div>
                    ) : null
                }
            </Form.Group>
            <Form.Group className='form-group'>
                <Form.Label>Service type</Form.Label>
                <Form.Select
                    id={isReturnShipmentTab ? 'returnData.serviceType' : 'serviceType'}
                    disabled={isMps}
                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.serviceType' : 'serviceType')}
                >
                    <option value=''>Select an option</option>
                    {
                        values.country && values.country !== 'US' ?
                            serviceTypesInternational.map((i) => (
                                <option key={i.value} value={i.value}>{i.key}</option>
                            ))
                            :
                            serviceTypesDomestic.map((i) => (
                                <option key={i.value} value={i.value}>{i.key}</option>
                            ))
                    }
                </Form.Select>
                {
                    errors?.serviceType && touched?.serviceType ? (
                        <div className='error'>{errors?.serviceType}</div>
                    ) : null
                }
            </Form.Group>
            {values.serviceType === 'SMART_POST' &&
                <Form.Group className='form-group'>
                    <Form.Label>Indicia</Form.Label>
                    <Form.Select
                        id={isReturnShipmentTab ? 'returnData.indicia' : 'indicia'}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.indicia' : 'indicia')}
                    >
                        <option value=''>Select an option</option>
                        {
                            indiciaTypes.map((i) => (
                                <option key={i.value} value={i.value}>{i.key}</option>
                            ))
                        }
                    </Form.Select>
                </Form.Group>
            }
            <Form.Group className='form-group'>
                <Form.Label>Package type</Form.Label>
                <Form.Select
                    id={isReturnShipmentTab ? 'returnData.packageType' : 'packageType'}
                    disabled={isMps}
                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.packageType' : 'packageType')}
                >
                    <option value=''>Select an option</option>
                    {
                        packageTypes.map((i) => (
                            <option key={i.key} value={i.value}>{i.key}</option>
                        ))
                    }
                </Form.Select>
                {
                    errors?.packageType && touched?.packageType ? (
                        <div className='error'>{errors?.packageType}</div>
                    ) : null
                }
            </Form.Group>
            {values.country === 'CA' &&
                <Form.Group className='form-group'>
                    <Form.Label>Sub-packaging type</Form.Label>
                    <Form.Select
                        id={isReturnShipmentTab ? 'returnData.subPackagingType' : 'subPackagingType'}
                        disabled={isMps}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.subPackagingType' : 'subPackagingType')}
                    >
                        <option value=''>Select an option</option>
                        {
                            subPackagingTypes.map((i) => (
                                <option key={i} value={i}>{i}</option>
                            ))
                        }
                    </Form.Select>
                </Form.Group>
            }
            <Form.Group className='form-group'>
                <Form.Label>Package dimensions</Form.Label>
                <InputGroup>
                    <Form.Control
                        id={isReturnShipmentTab ? 'returnData.length' : 'length'}
                        type='number'
                        onWheel={(e) => e.target.blur()}
                        placeholder='length'
                        disabled={isMps}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.length' : 'length')}
                    />
                    <InputGroup.Text>x</InputGroup.Text>
                    <Form.Control
                        id={isReturnShipmentTab ? 'returnData.width' : 'width'}
                        type='number'
                        onWheel={(e) => e.target.blur()}
                        placeholder='width'
                        disabled={isMps}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.width' : 'width')}
                    />
                    <InputGroup.Text>x</InputGroup.Text>
                    <Form.Control
                        id={isReturnShipmentTab ? 'returnData.height' : 'height'}
                        type='number'
                        onWheel={(e) => e.target.blur()}
                        placeholder='height'
                        disabled={isMps}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.height' : 'height')}
                    />
                    <Form.Select
                        id={isReturnShipmentTab ? 'returnData.dimensionsUnit' : 'dimensionsUnit'}
                        disabled={isMps}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.dimensionsUnit' : 'dimensionsUnit')}
                    >
                        <option value=''>Select an option</option>
                        <option value='IN'>in</option>
                        <option value='CM'>cm</option>
                    </Form.Select>
                </InputGroup>
            </Form.Group>
            <Form.Group className='form-group'>
                <Form.Label>Package description</Form.Label>
                <Form.Control
                    id={isReturnShipmentTab ? 'returnData.packageDescription' : 'packageDescription'}
                    type='text'
                    disabled={isMps}
                    {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.packageDescription' : 'packageDescription')}
                />
                {
                    errors?.packageDescription && touched?.packageDescription ? (
                        <div className='error'>{errors?.packageDescription}</div>
                    ) : null
                }
            </Form.Group>
            {!isReturnShipmentTab &&
                <Form.Group className='form-group'>
                    <Form.Label>Ship date</Form.Label>
                    <Form.Control
                        id={isReturnShipmentTab ? 'returnData.shipDate' : 'shipDate'}
                        type='date'
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.shipDate' : 'shipDate')}
                    />
                </Form.Group>}
            <Form.Group className='form-group'>
                <Form.Label>Declared value</Form.Label>
                <InputGroup>
                    <Form.Control
                        id={isReturnShipmentTab ? 'returnData.declaredValue' : 'declaredValue'}
                        type='number'
                        onWheel={(e) => e.target.blur()}
                        disabled={isMps}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.declaredValue' : 'declaredValue')}
                        value={isMps ? getTotalValue() : values.declaredValue}
                    />
                    <Form.Select
                        id={isReturnShipmentTab ? 'returnData.declaredValueCurrency' : 'declaredValueCurrency'}
                        disabled={isMps}
                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.declaredValueCurrency' : 'declaredValueCurrency')}
                    >
                        <option value=''>Select an option</option>
                        {
                            currencies.map((i) => (
                                <option key={i.code} value={i.code}>{i.code} - {i.currency}</option>
                            ))
                        }
                    </Form.Select>
                </InputGroup>
            </Form.Group>
            {values.returnLabelType === 'GROUND_CALL_TAG' &&
                <>
                    <Form.Group className='form-group'>
                        <Form.Label>Ready pickup date/time</Form.Label>
                        <Form.Control
                            id='returnData.readyPickupDateTime'
                            type='datetime-local'
                            {...formik.getFieldProps('returnData.readyPickupDateTime')}
                        />
                    </Form.Group>
                    <Form.Group className='form-group'>
                        <Form.Label>Latest pickup date/time</Form.Label>
                        <Form.Control
                            id='returnData.latestPickupDateTime'
                            type='datetime-local'
                            {...formik.getFieldProps('returnData.latestPickupDateTime')}
                        />
                    </Form.Group>
                </>}
            {values.country && values.country !== 'US' && values.packageContains === 'document' &&
                <Form.Group className='form-group'>
                    <Form.Label>Total customs value</Form.Label>
                    <InputGroup>
                        <Form.Control
                            id={isReturnShipmentTab ? 'returnData.totalCustomsValue' : 'totalCustomsValue'}
                            type='number'
                            onWheel={(e) => e.target.blur()}
                            {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.totalCustomsValue' : 'totalCustomsValue')}
                        />
                        <Form.Select
                            id={isReturnShipmentTab ? 'returnData.totalCustomsValueCurrency' : 'totalCustomsValueCurrency'}
                            {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.totalCustomsValueCurrency' : 'totalCustomsValueCurrency')}
                        >
                            <option value=''>Select an option</option>
                            {
                                currencies.map((i) => (
                                    <option key={i.code} value={i.code}>{i.code} - {i.currency}</option>
                                ))
                            }
                        </Form.Select>
                    </InputGroup>
                </Form.Group>}
            {isReturnShipmentTab && values.returnLabelType === 'PENDING' &&
                <>
                    <Form.Group className='form-group'>
                        <Form.Label>Email label to</Form.Label>
                        <Form.Control
                            id='returnData.emailLabelTo'
                            type='text'
                            {...formik.getFieldProps('returnData.emailLabelTo')}
                        />
                    </Form.Group>
                    <Form.Group className='form-group'>
                        <Form.Label>Expiration date</Form.Label>
                        <Form.Control
                            id='returnData.emailReturnExpirationDate'
                            type='date'
                            {...formik.getFieldProps('returnData.emailReturnExpirationDate')}
                        />
                    </Form.Group>
                    <Form.Group className='form-group'>
                        <Form.Label>Email return message</Form.Label>
                        <Form.Control
                            id='returnData.emailReturnMessage'
                            type='text'
                            {...formik.getFieldProps('returnData.emailReturnMessage')}
                        />
                    </Form.Group>
                </>}
            {isReturnShipmentTab && values.returnLabelType === 'PRINT_RETURN_LABEL' &&
                <Form.Check
                    className='form-group'
                    type='checkbox'
                    id='returnData.returnInstructions'
                    label='Return instructions'
                    checked={formik.values.returnData.returnInstructions}
                    {...formik.getFieldProps('returnData.returnInstructions')}
                />}
            {isReturnShipmentTab && values.returnLabelType === 'PRINT_RETURN_LABEL' && values.returnInstructions &&
                <Form.Group className='form-group'>
                    <Form.Label>Additional instructions</Form.Label>
                    <Form.Control
                        id='returnData.additionalInstructions'
                        type='text'
                        {...formik.getFieldProps('returnData.additionalInstructions')}
                    />
                </Form.Group>}
        </>
    )
}